export const star_0 = require("./assets/stars/star_0.png");
export const star_1 = require("./assets/stars/star_1.png");
export const star_1_5 = require("./assets/stars/star_1.5.png");
export const star_2 = require("./assets/stars/star_2.png");
export const star_2_5 = require("./assets/stars/star_2.5.png");
export const star_3 = require("./assets/stars/star_3.png");
export const star_3_5 = require("./assets/stars/star_3.5.png");
export const star_4 = require("./assets/stars/star_4.png");
export const star_4_5 = require("./assets/stars/star_4.5.png");
export const star_5 = require("./assets/stars/star_5.png");